import config from 'config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    allChannels: {
        url: `${customerApi}/api/channels/all`,
        type: 'GET',
    },

    // 商家渠道：不包含默认，活动裂变
    businessChannels: {
        url: `${customerApi}/api/channels/custom`,
        type: 'GET',
    },

    // 创建渠道
    addChannel: {
        url: `${customerApi}/api/channels`,
        type: 'POST',
    },

    // 编辑渠道
    editChannel: {
        url: `${customerApi}/api/channels/{id}`,
        type: 'PUT',
    },
}
